<!-- 表口径列表 -->
<template>
  <a-row :gutter="10">
    <a-col :md="24" :sm="24">
      <a-card :bordered="false">
        <a-row :gutter="16" style="height: 100%;margin: 0px;">
          <!--
          <a-col :span="4" style="text-align: center;">
            <div class="ptz">
              
              <a-collapse :activeKey="activeKey" expand-icon-position="right" style="text-align: left;">
                <a-collapse-panel key="1" header="组织树">
                  <a-tree :selectedKeys="selectedKeys" :tree-data="treeData" :replace-fields="replaceFields"
                    @select="TreeNodeClick" :defaultExpandAll="true" />
                </a-collapse-panel>
                
                <a-collapse-panel key="2" header="云台">
                  <div class="ptz-block" >
                    
                    <a-row>
                      <a-col style="padding: 5px;" span="8" v-for="item in directOprions" :key="item.key">
                        <a-tooltip>
                          <template #title>{{item.text}}</template>
                          <a-button shape="circle" @click="directionControl(item.direct,item.command)">
                            <a-icon :type="item.icon" :style="item.angle" />
                          </a-button>
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col style="padding: 5px;" :span="8" v-for="item in directOperation" :key="item.key">
                        <a-tooltip>
                          <template #title>{{item.text}}</template>
                          <a-icon :type="item.icon" style="font-size: 25px;"
                            @click="directionOperation(item.direct,item.command,item.operateType)" />
                        </a-tooltip>
                      </a-col>
                    </a-row>
                    
                  </div>
                </a-collapse-panel>
              
              </a-collapse>
              
            </div>
          </a-col>
          -->
          <a-col :span="24">
            <a-spin tip="Loading..." :spinning="loading">
              <div id="video">
              </div>
            </a-spin>
          </a-col>
        </a-row>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import '@/utils/video/imouplayer.js'
  import { postAction,getAction } from '@/api/manage'
  export default {
    name: 'videoRealTime',
    mixins:[/*JeecgListMixin,*/ mixinDevice],
    components: {
      
    },
    data () {
      return {
        description: this.$t('meter_caliber管理页面'),
        loading: true,
        url: {
          list: "/jeecg-charge/meter/meterCaliber/list",
          channelList:'/jeecg-charge/video/videoChannelRecord/list',
          treeList: '/jeecg-charge/video/videoChannelRecord/treeList',
          queryVideoPathList: '/jeecg-charge/video/videoControl/queryVideoPathList',
          controlMovePTZ: "/jeecg-charge/video/videoControl/controlMovePTZ"
        },
        dictOptions:{},
        player:null,
        activeKey: ['1'],
        selectedKeys: [],
        treeData: [],
        replaceFields: {
          children: 'children',
          title: 'deviceName',
          key: 'channelId',
        },
        Channelnumber: {},
        currentNum: 0,
        directOprions: [
          { key: 1,direct: 4, command: 1, text: '左上', icon: 'caret-left', angle: 'transform:rotate(45deg)' },
          { key: 2, direct: 0, command: 1, text: '上', icon: 'caret-up' },
          { key: 3, direct: 6, command: 1, text: '右上', icon: 'caret-up', angle: 'transform:rotate(45deg)' },
          { key: 4, direct: 2, command: 1, text: '左', icon: 'caret-left' },
          { key: 5, direct: 10, command: 0, text: '暂停', icon: 'pause' },
          { key: 6, direct: 3, command: 1, text: '右', icon: 'caret-right' },
          { key: 7, direct: 5, command: 1, text: '左下', icon: 'caret-down', angle: 'transform:rotate(45deg)' },
          { key: 8, direct: 1, command: 1, text: '下', icon: 'caret-down' },
          { key: 9, direct: 7, command: 1, text: '右下', icon: 'caret-right', angle: 'transform:rotate(45deg)' },
        ],
        directOperation: [
          { key: 11, direct: 1, command: 1, operateType: 2, text: '变焦+', icon: 'zoom-in' },
          { key: 12, direct: 1, command: 1, operateType: 1, text: '变倍+', icon: 'plus-square' },
          { key: 13, direct: 1, command: 1, operateType: 3, text: '光圈+', icon: 'plus-circle' },
          { key: 14, direct: 2, command: 1, operateType: 2, text: '变焦-', icon: 'zoom-out' },
          { key: 15, direct: 2, command: 1, operateType: 1, text: '变倍-', icon: 'minus-square' },
          { key: 16, direct: 2, command: 1, operateType: 3, text: '光圈-', icon: 'minus-circle' },
        ],

      }
    },
    created() {
    },
    mounted() {
      this.$nextTick(() => {
        this.queryVideoTreeList();
        this.loadData()
      })
      
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      // 接口请求
      queryVideoTreeList() {
        console.log('请求视频接口');
        this.treeData = [];
        getAction(this.url.treeList,{pageNo: 1,pageSize: 100}).then(res=>{
          if(res.success){
            let result = res.result;
            console.log(result);
            result[0].key = '0-0';
            this.treeData = result;
            /*
            this.treeData.push({
              deviceName: '6JO10E1PAZF0E45',
              key: '0-0',
              children: result.records,
            });
            */
            console.log('列表', this.treeData);
          }
        })
      },
      loadData() {
        this.loading = true;
        this.player = new ImouPlayer('#video');
        getAction(this.url.queryVideoPathList,{deviceId: '6JO10E1PAZF0E45'}).then(res=>{
          if(res.success){
            let pathList = res.result;
            if(pathList.length>9) {
              pathList= pathList.slice(0,9)
            }
            //播放器初始化
            this.player.setup({
              src: pathList,
              // src: [
              //   {
              //     // url拼接说明请见：1.3 轻应用播放地址说明
              //     url: 'imou://open.lechange.com/6JO10E1PAZF0E45/0/1?streamId=1',
              //     // 播放Token，通过接口getKitToken获取，具体请见：1.4 getKitToken接口协议说明 
              //     kitToken: 'Kt_hz99dfd69ed77941d1bebf25c6304c58', 
              //   },
              //   {
              //     // url拼接说明请见：1.3 轻应用播放地址说明
              //     url: 'imou://open.lechange.com/6JO10E1PAZF0E45/1/1?streamId=1',
              //     // 播放Token，通过接口getKitToken获取，具体请见：1.4 getKitToken接口协议说明 
              //     kitToken: 'Kt_hzfb8108d05913449ba705a6e95a4107', 
              //   },
              //   {
              //     // url拼接说明请见：1.3 轻应用播放地址说明
              //     url: 'imou://open.lechange.com/6JO10E1PAZF0E45/2/1?streamId=1',
              //     // 播放Token，通过接口getKitToken获取，具体请见：1.4 getKitToken接口协议说明 
              //     kitToken: 'Kt_hz605543b78ef84a2a8be560fd0cb0bc', 
              //   }
              // ], // 播放地址
              width: '100%', // 播放器宽度
              height: 600, // 播放器高度
              poster: '', // 封面图url
              autoplay: true, // 是否自动播放
              controls: true, // 是否展示控制栏
              setMultiScreen: 9,// 设置多屏
            });
            this.player.play();
          }
        }).finally(()=> {
          this.loading = false;
        })
        
      },
      //树节点 点击
      TreeNodeClick(key, e) {
        console.log('啦啦：' + key);
        this.selectedKeys = [key];
        console.log(e.node);
        this.Channelnumber = e.node.dataRef;
        this.currentNum = e.node.dataRef.channelId;
        console.log(this.selectedKeys);
        //selectedKeys.value.splice(0,1,key);
        // 选中窗口
        //video1.videoPlayer.chooseWindow(currentNum);
      },
      directionControl(direct, command) {
        let params = { deviceId: '6JO10E1PAZF0E45',operation: direct, channelId: 1 };
        postAction(this.url.controlMovePTZ,params).then(res=>{
          console.log('方向控制', params);
        })
        
      },
      directionOperation(direct, command, operateType) {
        let params = { direct: direct, command: command, operateType: operateType, channelCode: this.Channelnumber.channelId, step: 2 };
        postAction(this.url.list,params).then(res=>{
          console.log('缩放控制', params);
        })
        
      }
    },
    beforeDestroy() {
      if(this.player) {
        this.player.destroy()
      }
    }
  }
</script>
<style scoped>
</style>